import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
//import { NxModule } from '@nrwl/nx';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { AppRoutingModule } from './app-routing.module';
import { AppCoreModule } from '../lib/core/app.core.module';
import { AppSharedModule } from '../lib/shared/app.shared.module';
import { CoreModule } from '@fs/core';
import { PfevCoreModule } from '@fs/pfev';
@NgModule({
  declarations: [AppComponent, HeaderComponent, FooterComponent],
  imports: [BrowserModule, CoreModule, AppCoreModule, AppSharedModule, PfevCoreModule,/*NxModule.forRoot(),*/ AppRoutingModule],
  providers: [],
  bootstrap: [AppComponent],

})
export class AppModule {}
